import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

/** Sesión única: el equivalente para HttpClient de los interceptores de axios de SessionService. */
@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  // Resuelto al vuelo: SessionService depende de servicios que usan HttpClient
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sessionService = this.injector.get(SessionService);
    if (!sessionService.targetsBackend(req.url)) {
      return next.handle(req);
    }
    const sesion = sessionService.getSessionId();
    const request = sesion ? req.clone({ setHeaders: { sesion } }) : req;
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        sessionService.handleErrorResponse(error.status, error.error);
        return throwError(() => error);
      })
    );
  }
}
